import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Field, Input, Select } from '../../components/ui.tsx';

export type StatusFilter = 'all' | 'active' | 'inactive';

/** Pesquisa e filtro de situação, iguais em todas as telas da Estrutura Funcional. */
export function StructureFilters({
  q,
  onQ,
  status,
  onStatus,
  children,
}: {
  q: string;
  onQ: (v: string) => void;
  status: StatusFilter;
  onStatus: (v: StatusFilter) => void;
  children?: ReactNode;
}) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-wrap items-end gap-3">
      <Field label={t('structure.search')}>
        <Input
          value={q}
          placeholder={t('structure.searchPlaceholder')}
          onChange={(ev) => onQ(ev.target.value)}
        />
      </Field>
      <Field label={t('fields.status')}>
        <Select value={status} onChange={(ev) => onStatus(ev.target.value as StatusFilter)}>
          <option value="active">{t('structure.statuses.active')}</option>
          <option value="inactive">{t('structure.statuses.inactive')}</option>
          <option value="all">{t('structure.statuses.all')}</option>
        </Select>
      </Field>
      {children}
    </div>
  );
}

/** Filtro local: texto (sem diferenciar maiúsculas) em qualquer campo e situação. */
export function filterRows<T extends { isActive: boolean }>(
  rows: T[],
  q: string,
  status: StatusFilter,
  fields: (row: T) => (string | null | undefined)[],
): T[] {
  const needle = q.trim().toLowerCase();
  return rows.filter(
    (r) =>
      (status === 'all' || r.isActive === (status === 'active')) &&
      (!needle || fields(r).some((v) => v?.toLowerCase().includes(needle))),
  );
}

/** Aviso quando a pessoa só consulta: diz qual perfil libera incluir, editar e inativar. */
export function ReadOnlyNote({ show }: { show: boolean }) {
  const { t } = useTranslation();
  if (!show) return null;
  return <p className="text-sm text-muted">{t('structure.readOnlyNote')}</p>;
}
